import styles from "./tagMapping.module.css";
import { useDispatch, useSelector } from "react-redux";
import { addTags, removeTag } from "../../Utils/Redux/TagSlice";
import { Icon } from 'react-icons-kit';
import { check } from 'react-icons-kit/feather/check'
import { useEffect, useState, useSyncExternalStore } from "react";
import { BASE_URL, GET_ALL_TAGS, SUBMIT_TAGS, TAGS_BY_ISSUER, USER_TOKEN } from "../../Utils/constant";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import cogoToast from "cogo-toast-react-17-fix";
import useRefreshToken from "../../Hooks/usegenerateToken";
import API from "../../ApiConfig"
import { MESSAGE } from "../../Utils/Strings";
import IssuerNavigator from "../../components/DashBoard/IssuerNavigator";
import Breadcrumb from "../../components/Verifier/breadcrumb/BreadCrumb";

const TagMapping = ({ id, doc_name }) => {
  useRefreshToken(BASE_URL + USER_TOKEN)

  const navigate = useNavigate();

  const [TagList, setTaglist] = useState(Array(7).fill().map((_, index) => index + 1))
  const [search, setSearch] = useState(null)
  const [searchList, setSearchList] = useState(TagList)
  const [loading, setLoading] = useState(false)
  const [submit, setsubmit] = useState(false)

  const getTagsById = () => {
    API.get(TAGS_BY_ISSUER + id)
      .then(data => {
        let res = data.data
        if (res.data) {
          setTagItems(res.data)
          
        }
        setLoading(false)
      })
      .catch(err =>
        cogoToast.error(err.message)
      )
  }
  useEffect(() => {
    setLoading(true)
    API.get(GET_ALL_TAGS)
      .then(data => {
        let res = data.data
        setTaglist(res.data)
        setSearchList(res.data)
        getTagsById()
      })
      .catch(err => {
        if (err?.response)
          cogoToast.error(err.response.data.message)
        else
          cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
      })

  }, [])

  const ToggleTags = ({ i }) => {
    var Tags = TagItems.find((ii) => (ii.field_id === i.field_id) || (ii.id === i.field_id))
    if (Tags) {
      if (Tags.is_default) {
        return (loading?<div className="shimmer" style={{width:"5rem"}}></div>:<div className="btn btn-primary" onClick={() => cogoToast.error("Cannot modify default fields")}>Added</div>)
      }
      else {
        return (loading?<div className="shimmer" style={{width:"5rem"}}></div>:<div className="btn btn-primary" onClick={() => TagRemove(i.field_id)}>Added</div>)
      }
    }
    else {
      return (loading?<div className="shimmer" style={{width:"5rem"}}></div>:<div className="btn btn-secondary" onClick={() => TagAdd(i.field_id)}>+ Add</div>)
    }
  }

  const SearchTags = () => {
    setSearchList(TagList.filter(e => e.field_name.toLowerCase().includes(search.toLowerCase())))
  }

  const resetSearch = () => {
    setSearch('')
    setSearchList(TagList)
  }

  const [TagItems, setTagItems] = useState(Array(4).fill().map((_, index) => index + 1))
  const dispatch = useDispatch();

  const TagRemove = (id) => {
    dispatch(removeTag(id))
    setTagItems(TagItems.filter((i) => i.field_id != id))
  }

  const TagAdd = (id) => {
    dispatch(addTags(TagList.filter(item => item.field_id === id)))
    const matchId=TagList.filter(item => item.field_id === id)
    setTagItems(TagItem => [...TagItem,...matchId])
  }

  const submitTags = () => {
    setsubmit(true)
    let doc_fields = []
    for (let i in TagItems) {
      doc_fields.push({
        field_name: TagItems[i].field_name,
        is_required: TagItems[i].is_required ? TagItems[i].is_required : false,
        hide_in_pdf:TagItems[i].hide_in_pdf
      })
    }
    let formData = {
      document_id: parseInt(id),
      doc_fields
    }
    const hasNonDefaultField = formData.doc_fields.some(field => field.is_required === false)
    if(hasNonDefaultField){
    API.post(SUBMIT_TAGS, formData)
      .then(data => {
        let res = data.data
        if (res.status == 200) {
          navigate('/Create/' + id + '/Layout')
          // setTaglist(data.data)
        }
        else {
          cogoToast.error("some error occured while saving the tags")
        }
      })
      .catch(err => {
        cogoToast.error(err.response.data.detail)
      }
      )
      .finally(() => {
        setsubmit(false)
      })
    }
    else{
      cogoToast.info("Please add atleast 1 non-default tag")
    }
  }

  function is_mandatory(id) {
    setTagItems(prevItems =>
      prevItems.map(item =>
        item.field_id == id ? { ...item, is_required: !item.is_required } : item
      )
    );
  }
  const useTemplate = () => {

    const handleNavigate = (link) => {
        navigate(link)
    }
    return (
        // list.length > 0 &&
        <div className="navItemContainer">
            <button className="btn btn-primary" onClick={e=>submitTags(e)} style={{ width: '10rem' }}>Create design <img src='/rightchevron.svg' loading='lazy' alt='rightchevron.svg'/></button>
        </div>
    )
}
 const showtags = (tags) => {
            let n = tags.length
            if (n > 0) {
                return (
                    <span className={styles.supportingDocuments} title={tags.map(e => e.master_document_name).join(", ")}>
                        {tags[0].master_document_name}{n - 1 != 0 ? (' +' + (n - 1)) : null}
                    </span>
                )
            }
            return (
                <span className={tagmap.notRequired}>Not required</span>
            )
        }


  const handleHideOnPdf=(id,e)=>{
    setTagItems((prevItems)=>(
      prevItems.map((field)=>(
        field.field_id==id?
        {...field,hide_in_pdf:e}:field
      ))
    ))    
  }
  console.log(TagItems);
  
  
  return (
    <>
    <Breadcrumb title={"Create New Template"} pos={2} category={"template"}/>
    <IssuerNavigator title="Assign Tags" step={"/dashboard/mydocuments"} actions={useTemplate}/>
    <div className={styles.MappingBody}>
      <Loader isOpen={loading} />
      <div>
        <div className={styles.search}>
          <h1 className={styles.tableheader}>All Tag</h1>
          <div className={styles.searchbox}>
            <div className={styles.inputbox}>
              <img src='/searchoutline.svg' />
              <input className={styles.input} onChange={e => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); SearchTags(); } }} value={search} />
              {search ? <img src='/x.svg' onClick={resetSearch} className={styles.closeSearch} /> : <></>}
            </div>
            <button className={styles.searchButton} onClick={SearchTags} disabled={!search}>Search</button>
          </div>
        </div>
        {/* <div className={styles.tagMenu}>
          <table>
            <tbody>
              <tr>
                <th className={styles.th}>Name</th>
              </tr>
            </tbody>
          </table>
        </div> */}
        <div className={styles.select}>
          {searchList.map((i) => (
            <div className={styles.listItems} key={i.field_id}>
              <div>
                <div className={styles.listTitle}>
                  {loading ? <div className="shimmer" style={{ width: "7rem" }}></div> : i.field_name}
                </div>
                {/* <div className={styles.listDesc}>
                  {loading ? <div className="shimmer" style={{ width: "15rem" }}></div> : i.description}
                </div> */}
              </div>
              <ToggleTags i={i} />
            </div>)
          )}
        </div>
      </div>
      <div className={styles.selected}>
        <div className={styles.tableheader} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {/* <h1 className={styles.tableheader + " " + styles.search}>{loading ? <div className="shimmer" style={{ width: "10rem" }}></div> : <>Document Tags({TagItems.length})</>}</h1> */}
          {/* <div className={styles.search}><button className={styles.Button} onClick={e => submitTags(e)}>{submit ? <>Creating...</> : <>Create design <img src="/rightchevron.svg" alt="rightchevron.svg"/></>}</button></div> */}
        </div>
        <h1 className={styles.tableheader + " " + styles.search} style={{padding:"10px"}}>{loading ? <div className="shimmer" style={{ width: "10rem" }}></div> : <><div className={styles.tagType}>Document Name</div> <div>{doc_name}</div></>}</h1>
        <div className={styles.taglistTable}>
          <div style={{width:"100%"}}>
        <table className={styles.table}>
        <h1 className={styles.tableheader + " " + styles.search} style={{padding:"10px"}}>{loading ? <div className="shimmer" style={{ width: "10rem" }}></div> : <>Document Tags({TagItems.length})</>}</h1>
          <tr>
            <th className={styles.th}>Variable</th>
            {/* <th className={styles.th}>Description</th> */}
            {/* <th className={styles.th}>Mandatory field</th> */}
            <th className={styles.th}>Dynamic Tag</th>
            <th className={styles.th}>Supporting Document <button className={styles.editBtn} onClick={e=>submitTags(e)}>Edit</button></th>
            <th className={styles.th}>Hide Tag</th>
          </tr>
          {TagItems.map((el) => {
            return (
              <tr key={el.field_id} style={el.is_default ? { opacity: 0.5 } : null}>
                <td className={styles.td}>{loading ? <div className="shimmer"></div> :<div className={styles.fieldsName} style={el.is_default?null : {color:"#375DFB"}} onClick={!el.is_default ? () => TagRemove(el.field_id) : () => cogoToast.error("Cannot modify default fields")}><div> {el.field_name} </div> <div> <img src="/delete.svg" alt="delete.svg" className={styles.removeButton}/></div></div>} </td>
                {/* <td className={styles.td}>{loading ? <div className="shimmer"></div> : el.description}</td> */}
                {/* <td className={styles.td}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {
                      loading ?
                        <div className="shimmer"></div> :
                        el.is_required ?
                          <div className={styles.addMandatory + " " + styles.added} onClick={!el.is_default ? () => is_mandatory(el.field_id) : () => cogoToast.error("Cannot modify default fields")}>
                            <Icon icon={check} size={"1.3rem"} style={{ color: "white" }} />
                          </div>
                          :
                          <div className={styles.addMandatory + " " + styles.toadd} onClick={() => is_mandatory(el.field_id)}></div>
                    }
                  </div>
                </td> */}
                <td className={styles.td}>{loading ? <div className="shimmer"></div> : el.html_tag}</td>
                <td className={styles.td}>
                  {loading ? <div className="shimmer"></div> :
                    <div className={styles.supportDoc}>
                      {el.supporting_docs && el.supporting_docs.length > 0 ? showtags(el.supporting_docs): <div className={styles.notRequired}>Not Required</div>}
                    </div>}
                </td>
                <td className={styles.td}><input type="checkbox" checked={el.hide_in_pdf} onChange={(e)=>handleHideOnPdf(el.field_id,e.target.checked)} disabled={el.is_default}/></td>
              </tr>
            )
          })}
        </table>
        </div>
        <div>
          <div className={styles.tagInfo}>
            {loading?<div className="shimmer" style={{width:"24rem", height:"7rem"}}></div>:
            <>
            <span style={{fontWeight:"500"}}>What are dynamic tags</span><br/>
            <span className={styles.text}>Insert the dynamic tags description here. It would look better as two lines of text.</span><br/>
            <span className={styles.learnMore}>Learn More</span>
            </>}
          </div>
          <div className={styles.tagInfo}>
            {loading?<div className="shimmer" style={{width:"24rem", height:"7rem"}}></div>:
            <>
            <span style={{fontWeight:"500"}}>What is supporting document?</span><br/>
            <span className={styles.text}>Insert the dynamic tags description here. It would look better as two lines of text.</span><br/>
            <span className={styles.learnMore}>Learn More</span>
            </>}
          </div>
        </div>
        </div>

      </div>
    </div>
    </>
  );
};

export default TagMapping;
